import React from 'react';
import {useStyles} from "../TopupProducts.style";
import clsx from "clsx";
import TopupProductRowProperties from "./TopupProductsRowProperties";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import ExpandoMenu from "../../../ui_components/ExpandoMenu/ExpandoMenu";
import ShowProduct from '../../../shared_components/Info/ShowProduct/ShowProduct';
import ShowProductEnable from '../../../shared_components/Info/ShowProductEnable/ShowProductEnable';
import EditTopupProductEnableButton from '../../../shared_components/Buttons/EditTopupProductEnableButton/EditTopupProductEnableButton';

const TopupProductRowMedium: React.FC<TopupProductRowProperties> = ({
                                                            topupProduct,
                                                            onUpdate = () => {
                                                            },
                                                        }) => {

    const classes = useStyles();

    return (
        <div
            className={clsx(classes.topup_price_info_container)}>
            <ShowProduct value={topupProduct ?? undefined}/>
            <ShowProductEnable value={topupProduct ?? undefined}/>
            <ExpandoMenu>
               <>
                   <EditTopupProductEnableButton
                       size={ButtonSize.SMALL}
                       onSave={onUpdate}
                       showText
                       topupProductId={topupProduct?.id}
                       type={ButtonType.SECONDARY}
                   />
               </>
            </ExpandoMenu>
        </div>
    )
}

export default TopupProductRowMedium;
